/**
 * Back redirect do checkout (spec 045, 3.10), sem tela: o que o campo manda pro servico e quando ele mostra o erro. A
 * regra do endereco (so `https://` completo) e a do servico de pagamentos, no `@mtc/contratos`; o servico confere de novo.
 */
import { ERRO_DO_VOLTAR_PARA, voltarParaValido } from "@mtc/contratos";

const COMECO = "https://";

/** O que vai pro servico: vazio vira nulo (o voltar leva pro site da marca). */
export const voltarParaDoCampo = (valor: string): string | null => valor.trim() || null;

/** Vazio vale (o site da marca); preenchido, so endereco https completo. */
export const campoDeVoltarParaOk = (valor: string): boolean => !valor.trim() || voltarParaValido(valor);

/**
 * O erro do campo. Aparece quando o endereco ja nao tem como dar certo (nao comeca por `https://`, como `http://` ou
 * `www.`) ou quando a pessoa sai do campo com ele incompleto. Enquanto ela digita o comeco (`htt`, `https://mtcprop`),
 * nao: o botao fica travado, mas o campo nao grita a cada letra.
 */
export function erroDoVoltarPara(valor: string, saiuDoCampo: boolean): string | undefined {
  const e = valor.trim();
  if (!e || voltarParaValido(e)) return undefined;
  const minusculo = e.toLowerCase();
  const digitandoOComeco = COMECO.startsWith(minusculo) || minusculo.startsWith(COMECO);
  return saiuDoCampo || !digitandoOComeco ? ERRO_DO_VOLTAR_PARA : undefined;
}
